import React, {useCallback, useContext, useEffect, useState} from 'react';
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import DataEditor from "../../../../shared/components/dataEditor/DataEditor";
import {Button} from "antd";
import {internalApi} from "../../../../common/axios";
import toast from "react-hot-toast";
import styles from './PlayInfo.module.css';
import dayjs from "dayjs";

const PlayInfo = () => {
    const {playerData} = useContext(PlayerContext);
    const [playInfo, setPlayInfo] = useState(playerData.playerInfo);
    const [isModified, setIsModified] = useState(false);

    useEffect(() => {
        setPlayInfo(playerData.playerInfo);
    }, [playerData.playerInfo]);

    const handleEdit = useCallback((path, newValue) => {
        setPlayInfo(currentData => {
            if (!path || path.length === 0) {
                return newValue;
            }

            const cloneSet = (node, idx) => {
                const key = path[idx];
                const isLast = idx === path.length - 1;

                if (Array.isArray(node)) {
                    const next = node.slice();
                    if (isLast) {
                        next[key] = newValue;
                    } else {
                        const child = node[key];
                        if (typeof child !== 'object' || child === null) {
                            console.error("Invalid path for editing: intermediate path not an object/array.", path);
                            return node;
                        }
                        next[key] = cloneSet(child, idx + 1);
                    }
                    return next;
                }

                if (node && typeof node === 'object') {
                    const next = {...node};
                    if (isLast) {
                        next[key] = newValue;
                    } else {
                        const child = node[key];
                        if (typeof child !== 'object' || child === null) {
                            console.error("Invalid path for editing: intermediate path not an object/array.", path);
                            return node;
                        }
                        next[key] = cloneSet(child, idx + 1);
                    }
                    return next;
                }

                console.error("Invalid path for editing: root is not object/array.", path);
                return currentData;
            };

            return cloneSet(currentData, 0);
        });
        setIsModified(true);
    }, []);

    const handleSavePlayInfo = async () => {
        try {
            await internalApi.post('/player/playInfo', {
                playInfo,
                userKey: playerData.userKey,
                syncId: playerData.syncId
            });
            toast.success("플레이 정보가 저장되었습니다.");
        } catch (e) {
            toast.error("플레이 정보 저장에 실패했습니다.");
        }
    }

    return (
        <div style={{ padding: 24, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
            <div>
                마지막 저장 시간: {dayjs.unix(playerData.syncId).format('YYYY-MM-DD HH:mm:ss')}
            </div>
            <DataEditor
                initialData={playInfo}
                handleEdit={handleEdit}
                downloadName={`playInfo_${playerData.userKey}_${dayjs().format('YYYYMMDD_HHmmss')}.json`}
            />
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
                <Button
                    type="primary"
                    className={isModified ? styles.saveBtn : `${styles.saveBtn} ${styles.disabled}`}
                    onClick={handleSavePlayInfo}
                    disabled={!isModified}
                >
                    저장
                </Button>
            </div>
        </div>
    );
};

export default PlayInfo;